import React from 'react';
import PropTypes from 'prop-types';
import type { ProgressbarProps, ProgressTextProps } from './Progressbar.types';
import './progressbar.scss';

const Progressbar = ({ style, label, color, progress, progressText, progressTop, showProgress }: ProgressbarProps) => {
  const progressPosition = progressTop ? 'sb-progressbar--top' : 'sb-progressbar--bottom';
  const isShowProgress = showProgress ? 'sb-progressbar--show-progress' : '';

  return (
    <div
      style={{ ...style }}
      className={['sb-progressbar',
        `sb-progressbar--${color}`,
        progressPosition,
        isShowProgress
      ].join(' ')}
      data-testid="sb-progressbar"
    >
      <div
        className="sb-progressbar__data"
        data-testid="sb-progressbar__data"
      >
        {!showProgress &&
          <span>{label}</span>
        }
        {(showProgress && progressTop) &&
          <ProgressText progressText={progressText} progress={progress} />
        }
      </div>
      <div
        className="sb-progressbar__container"
        data-testid="sb-progressbar__container"
      >
        <div
          style={{ width: `${progress}%` }}
          className="sb-progressbar__progress"
          data-testid="sb-progressbar__progress"
        />
      </div>
      {(showProgress && !progressTop) &&
        <div className="sb-progressbar__data--bottom">
          <ProgressText progressText={progressText} progress={progress} />
        </div>}
    </div>
  );
};

const ProgressText = ({ progressText, progress }: ProgressTextProps) => {
  const text = progressText ?
    progressText :
    `${progress}%`

  return (
    <p
      className="sb-progressbar__tag"
      data-testid="sb-progressbar__tag"
      style={{ right: `${100 - progress}%` }}
    >{text}</p>
  )
}

Progressbar.propTypes = {
  /**
 * Progressbar label
 */
  label: PropTypes.string,
  /**
* Progress %
*/
  progress: PropTypes.number.isRequired,
  /**
* progressText
*/
  progressText: PropTypes.string,
  /**
* show Progress?
*/
  showProgress: PropTypes.bool,
  /**
* Color of progressbar
*/
  color: PropTypes.oneOf(['normal', 'warning', 'success', 'error']),
  /**
* Progress top?
*/
  progressTop: PropTypes.bool,
  /**
* Progressbar style
*/
  style: PropTypes.object,
};

Progressbar.defaultProps = {
  label: "progressbar text",
  progress: 50,
  progressText: "",
  showProgress: true,
  color: "normal",
  progressTop: true,
  style: {}
};

export default Progressbar;